import httpService from './httpService';

export const getRoles = async () => {
	const { data } = await httpService.get(`/roles`);
	return data;
};
